import storage from './localStorage';

const getUserFromStorage = () => storage.getItem('user') || '';

export const getAuthTokenFromStorage = () => getUserFromStorage()?.token;

export function copyToClipboard(text: string) : boolean {
  // create temporary element
  const element = document.createElement('textarea');

  // add some styles to the temporary element
  element.value = text;
  element.style.height = '0';
  element.style.width = '0';
  element.style.position = 'fixed';
  element.style[document.dir === 'rtl' ? 'right' : 'left'] = '-1px';

  // insert temporary element to DO
  document.body.appendChild(element);

  // select content of temporary element
  element.select();
  element.setSelectionRange(0, element.value.length);

  // copy data to clipboard
  const result = document.execCommand('copy');

  // remove temporary element
  document.body.removeChild(element);

  return result;
}
